import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  events: [],
  error: null,
  loading: false,
};

const reformCalendarSlice = createSlice({
  name: "reformCalendar",
  initialState,
  reducers: {
    getEventsStart(state) {
      state.loading = true;
    },
    getEventsSuccess(state, action) {
      state.events = action.payload;
      state.loading = false;
      state.error = null;
    },
    getEventsError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    addEventSuccess(state, action) {
      state.events.push(action.payload);
    },
    updateEventSuccess(state, action) {
      state.events = state.events.map(event =>
        event.id === action.payload.id ? action.payload : event
      );
    },
    deleteEventSuccess(state, action) {
      state.events = state.events.filter(event => event.id !== action.payload);
    },
  },
});

export const {
  getEventsStart,
  getEventsSuccess,
  getEventsError,
  addEventSuccess,
  updateEventSuccess,
  deleteEventSuccess,
} = reformCalendarSlice.actions;

export default reformCalendarSlice.reducer;